import { ChatService } from 'src/services/ChatService';

export const chatService = new ChatService();
